/**
 * React Query hooks for discovery users
 */

import { useQuery } from "@tanstack/react-query";
import { discoveryService } from "../services/discoveryService";

/**
 * Query key factory for discovery users
 */
export const discoveryQueryKeys = {
  all: ["discovery"] as const,
  users: () => [...discoveryQueryKeys.all, "users"] as const,
  userList: (userId: string, limit: number, startWithUserId?: string) =>
    [...discoveryQueryKeys.users(), userId, limit, startWithUserId ?? null] as const,
};

/**
 * Hook to fetch discovery users
 */
export function useDiscoveryUsers(currentUserId: string, limit: number = 20, startWithUserId?: string) {
  return useQuery({
    queryKey: discoveryQueryKeys.userList(currentUserId, limit, startWithUserId),
    queryFn: () => discoveryService.getDiscoveryUsers(currentUserId, limit, startWithUserId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!currentUserId,
  });
}
